import { useTheme } from "@rentiohq/web-shared-next/dist/themes";
import { EFontWeights } from "@rentiohq/web-shared-next/dist/themes/types";

export const PaymentDetailStyles = () => {
  const theme = useTheme();
  return {
    content: {
      heading: {
        py: 2,
        px: 3,
        color: theme.palette.grey[900],
      },
      label: {
        color: theme.palette.grey[900],
      },
      date: {
        fontWeight: EFontWeights.Regular,
      },
      btn: {
        width: "240px",
      },
      bannerWrapper: {
        mt: 3,
        p: 2,
        borderRadius: "12px",
        background: theme.palette.grey[100],
      },
      bannerTitle: {
        color: theme.palette.grey[900],
      },
      bannerDetail: {
        color: theme.palette.grey[900],
        fontStyle: "italic",
      },
      divider: {
        mt: 2,
      },
    },
  };
};
